import { render, staticRenderFns } from "./SectionPoints.vue?vue&type=template&id=2faace75&"
import script from "./SectionPoints.vue?vue&type=script&lang=js&"
export * from "./SectionPoints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports